<template>
	<div>
		<!-- Modale utilisée pour apprécier un objet -->
		<b-modal v-if="NodeIsDepreciated"  v-model="localDisplayDepreciateModal" centered no-close-on-backdrop>
			<template #modal-header="{ }">
				<h6>{{ $t('Appreciate') }}</h6>
			</template>
			<!-- <font-awesome-icon icon="comment-question" class="pr-2" /> -->
			<p>{{ $t('ConfirmAppreciate') }}</p>
			<!-- <b-row class="w-100"> -->
			<!-- </b-row> -->
			<template #modal-footer="{ cancel }">
				<b-button @click="cancel();$emit('CloseDepreciateModal');" variant="secondary">{{ $t('No') }}</b-button>
				<b-button @click="appreciateObject()" variant="danger">{{ $t('Yes') }}</b-button>
			</template>
		</b-modal>
		<!-- Modale utilisée pour saisir une date de dépréciation d'un objet -->
		<b-modal v-else v-model="localDisplayDepreciateModal" centered no-close-on-backdrop>
			<template #modal-header="{ }">
				<h6>{{ $t('Depreciate') }}</h6>
			</template>
			<!-- <font-awesome-icon icon="comment-question" class="pr-2" /> -->
			<p>{{ $t('ConfirmDepreciate') }}</p>
			<!-- <b-row class="w-100"> -->
			<b-form-group
				:label="$t('Date')"
				label-cols-sm="2"
				label-for="eventDate"
				label-class="pt-0 pb-0 pr-0"
				label-align-sm="left">
				<b-input-group id="depreciatedDate" >
					<!-- @todo: gérer le format de la date selon que la culture soit française ou anglaise -->
					<b-form-datepicker :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
						:max="new Date()" locale="fr" start-weekday="1"
						value-as-date v-model="depreciatedDate" :placeholder="$t('SelectDateMessage')" />
				</b-input-group>
			</b-form-group>
			<!-- </b-row> -->
			<template #modal-footer="{ cancel }">
				<b-button @click="cancel();$emit('CloseDepreciateModal');" variant="outline-secondary">{{ $t('No') }}</b-button>
				<b-button @click="depreciate()" variant="danger">{{ $t('Yes') }}</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import locales from './locales/DepreciateObject.json';

/** Composant de gestion de la dépréciation/appréciation d'un objet */
@Component({
	components: { 
	},
	i18n: {messages: locales}
})
export default class DepreciateObject extends Vue {
	@Prop()
	public NodeId!: string;

	@Prop()
	public NodeIsDepreciated!: boolean;

	@Prop()
	public ObjectType!: string;

	@Prop()
	public SectionName!: string;

	/** Nom du tableau */
	@Prop()
	public TableName!: string;

	//#region Fenêtre modale de saisie d'un évènement
	@Prop()
	public DisplayDepreciateModal!: boolean;

	private localDisplayDepreciateModal: boolean = false;

	@Watch('DisplayDepreciateModal')
	private displayModal() {
		this.localDisplayDepreciateModal = this.DisplayDepreciateModal;
	}

	private depreciatedDate: Date = new Date();

	private cancel() {
		this.localDisplayDepreciateModal = false;
		this.depreciatedDate = new Date();
	}
	//#endregion Fenêtre modale de saisie d'un évènement
	
	private depreciate() {
		console.debug("DepreciateObject - depreciate - nodeId : " + this.NodeId);
		if (this.depreciatedDate) {
			console.debug("DepreciateObject - depreciate - nodeId : " + this.NodeId + " - childSectionToDepreciate : " + this.SectionName + " - tableFieldNameToDepreciate : " + this.TableName);

			this.$store.dispatch("ObjectStore/Depreciate", { nodeId: this.NodeId, objectType: this.ObjectType, depreciatedDate: this.depreciatedDate, childSectionToDepreciate: this.SectionName, tableFieldNameToDepreciate: this.TableName })
				.then(x => {
					this.localDisplayDepreciateModal = false;
					this.$emit('CloseDepreciateModal', true);
					this.$bvToast.toast(this.$t('DepreciateSuccess').toString(), { // $t('DepreciateSuccess') / "L'objet sélectionné a été déprécié avec succès.", {
						title: this.$t('DepreciateObject').toString(), // $t('DepreciateObject') / "Dépréciation objet"
						autoHideDelay: 3000,
						variant: "success",
						solid: true,
						appendToast: true,
						toaster: "b-toaster-top-center"
					});
				})
				.catch(err => {
					console.error(err);
					this.$bvToast.toast(err, {
						title: this.$t('DepreciateObjectError').toString(), // $t('DepreciateObjectError') / "Erreur dépréciation objet"
						autoHideDelay: 10000,
						variant: "danger",
						solid: true,
						appendToast: true,
						toaster: "b-toaster-top-center"
					});
				});
		}
	}

	private appreciateObject() {
		console.debug("DepreciateObject - appreciateObject - nodeId : " + this.NodeId + " - this.SectionName : " + this.SectionName + " - this.TableName : " + this.TableName);

		this.$store.dispatch("ObjectStore/Appreciate", { nodeId: this.NodeId, objectType: this.ObjectType, childSectionToAppreciate: this.SectionName, tableFieldNameToAppreciate: this.TableName })
			.then(x => {
				this.localDisplayDepreciateModal = false;
				this.$emit('CloseDepreciateModal', false);

				this.$bvToast.toast(this.$t('SelectedObjectAppreciated').toString(), { // $t('SelectedObjectAppreciated') / "L'objet sélectionné a été apprécié avec succès."
					title: this.$t('AppreciateObject').toString(), // $t('AppreciateObject') / "Appréciation objet",
					autoHideDelay: 3000,
					variant: "success",
					solid: true,
					appendToast: true,
					toaster: "b-toaster-top-center"
				});
			})
			.catch(err => {
				console.error(err);
				this.$bvToast.toast(this.$t('AnErrorOccured').toString(), { // $t('AnErrorOccured') / "Une erreur s'est produite."
					title: this.$t('AppreciateObjectError').toString(), // $t('AppreciateObjectError') / "Erreur appréciation objet"
					autoHideDelay: 10000,
					variant: "danger",
					solid: true,
					appendToast: true,
					toaster: "b-toaster-top-center"
				});
			});
	}
}
</script>

<style scoped>
</style>